<template>
  <main class="w-full" id="narrativeCanvas">
    <!-- CONTENT INJECTION HAPPENS HERE -->
    <div :id="e.Oid + '-container'" v-bind:class="{title: e.type == 'TITLE'}"  v-for="(e, idx) in narrative.elements" :key = "e.Oid">
      <div :id="e.Oid + '-trigger'"  v-bind:class="{titleTrigger: e.type == 'TITLE'}" >
        <!-- HERE IS A WEIRD HACK TO AVOID JITTER. ??? -->
        <span class="text-sm uppercase" v-if="true" style='opacity:0'>
          <!-- trigger {{ e.Oid }} // {{ e.type }} -->
          .
        </span>
      </div>
      <narrative-element
        :scale-factor="scaleFactor"
        :element="e"
      ></narrative-element>
    </div>
  </main>
</template>

<script>
// import Component from "../component_location"
import NarrativeElement from "@/components/NarrativeElements/NarrativeElement.vue";

export default {
  components: { NarrativeElement },

  props: {
    narrative: { type: Object, default: () => {} },
    debugMode: { type: Boolean, default: true },
    scaleFactor: { type: Number, default: 1 },
  },

  data() {
    return {};
  },

  watch: {},

  methods: {},

  computed: {},

  mounted() {
    // Tell the outside world that we're fully formed...
    this.$emit("ready");
  },
};
</script>

<style>
.title {
  top: 0;
  position: sticky;
  z-index: 1001;
}
.titleTrigger {
  height:0;
}

</style>
